module.exports = __webpack_public_path__ + "myprofile.16d447d4188702012b75.png";


//////////////////
// WEBPACK FOOTER
// /home/maheshreddy/PRP_FE/src/img/myprofile.png
// module id = ../../../../../src/img/myprofile.png
// module chunks = styles